import { ReactElement, useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import sha256 from "crypto-js/sha256";
import CopyToClipboard from "react-copy-to-clipboard";

import { Button, Input, Loader } from "@screencloud/screencloud-ui-components";
import { EditorStore } from "../../types";
import { RootState } from "../../reducers";
import { addPasswordAuth } from "../../actions";
import { ScreenCloudContext } from "../../ScreenCloudReactApp";

const PasswordAuth = (): ReactElement<{}> => {
  const dispatch = useDispatch();
  const { logger } = useContext(ScreenCloudContext);
  const editor: EditorStore = useSelector((state: RootState) => state.editor);

  const [password, setPassword] = useState("");
  const [passwordSaved, setPasswordSaved] = useState(
    editor.channel ? !!editor.channel.hasPassword : false
  );
  const [passwordCopied, setPasswordCopied] = useState(false);

  useEffect(() => {
    if (editor.channel) {
      if (editor.channel.hasPassword && !editor.editorAuthenticating) {
        setPasswordSaved(editor.channel.hasPassword);
      }
    }
  }, [editor]);

  if (editor.channel) {
    const { channel } = editor;

    return (
      <>
        <div className="row">
          <div className="label flex">Set Password</div>
          {editor.editorAuthenticating ? (
            <>
              <Loader
                size="medium"
                active
                inline="centered"
                className="auth-spinner"
              />
              <span className="auth-message">Setting Password...</span>
            </>
          ) : !passwordSaved ? (
            <div className="password-input">
              <form>
                <Input
                  type="password"
                  placeholder="Password"
                  value={password}
                  autoComplete="off"
                  onChange={(_, data) => {
                    setPassword(data.value);
                  }}
                />
              </form>
              <Button
                primary
                className="confirm-password"
                onClick={() => {
                  const hashedPassword = sha256(password);
                  const { screenCloudOrgId, spaceId, channelId } = channel;
                  dispatch(
                    addPasswordAuth(
                      {
                        screenCloudOrgId,
                        spaceId,
                        channelId,
                        password: hashedPassword.toString(),
                      },
                      logger
                    )
                  );
                }}
              >
                Confirm
              </Button>
            </div>
          ) : (
            <Button
              className="wide-button"
              primary
              onClick={() => {
                setPassword("");
                setPasswordSaved(false);
              }}
            >
              Change Password
            </Button>
          )}
        </div>
        {passwordSaved && !!password && (
          <div className="row">
            <div className="label flex">Copy Password</div>
            <CopyToClipboard
              text={password}
              onCopy={() => setPasswordCopied(true)}
            >
              <Button className="wide-button" primary>
                {passwordCopied ? "Copied" : "Copy Password"}
              </Button>
            </CopyToClipboard>
          </div>
        )}
      </>
    );
  }
  return <div />;
};

export default PasswordAuth;
